module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-005"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("THE SPIES ESCAPE JERICHO"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Joshua+2%3A15-24&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JOSHUA 2:15-24")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" Rahab’s words to the spies speak deeper truths of Christ and the rigor of the church’s journey (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). That all were to be gathered into one house for salvation is a figure for the church, outside of which no one is saved (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPRIAN")]), _vm._v("). The scarlet cord she bound in the window was a sign of her faith (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(") that mystically represented the shedding of the Lord’s blood (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(", O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). The window, which illumines the house with adequate light, anticipates the incarnation, which allows us to behold, in part, the splendor of Christ’s divinity (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-022"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("2:16 ")])]), _vm._v("Hide Yourselves in the Hills")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYS")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": She counsels them and says, “Wait here for three days.” Not one day does she specify, nor two days, but definitely three days. Notice what she says: “Wait three days.” She does not designate three nights but three days, for hers was an enlightened heart. Then she says, and after three days—but what does she say? “Do not go through the open plains,” she warns, “but go up the mountain way.” The faith of the church is not laid in the valleys but is established on the mountains. Later, indeed, Jericho is overthrown, but this harlot alone is preserved untouched; hence, the Lord says, “I will be mindful of Rahab”; that is, on the day of judgment, I will be mindful of her who "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("welcomes my messengers. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 18 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 86).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN92",
      "id": "ap_part1_NFIN92-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-023"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("2:17-20 ")])]), _vm._v("The Oath of the Spies")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSE OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Also this commandment is given to the person who was once a prostitute: “All,” it says, “who will be found in your house will be saved. But concerning those who go out from the house, we ourselves are free of them by your oath.” Therefore, if anyone wants to be saved, let him come into the house of this one who was once a prostitute. Even if anyone from that people wants to be saved, let him come in order to be able to attain salvation. Let him come to this house in which the blood of Christ is the sign of redemption. For among those who said, “His blood be upon us and upon our children,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN93",
      "id": "ap_part1_NFIN93-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" the blood of Christ is for condemnation. For Jesus had been appointed “for the ruin and the resurrection of many.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN94",
      "id": "ap_part1_NFIN94-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Therefore, for those refuting his sign, his blood effects punishment; for those who believe, salvation.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Let no one persuade himself, let no one deceive himself. Outside this house, that is, outside the church, no one is saved. If anyone goes outside, he is responsible for his own death. This is the significance of the blood, for this is also the purification that is manifest through the blood. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 3.5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN95",
      "id": "ap_part1_NFIN95-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSE")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPRIAN")]), _vm._v(": Rahab, who also was a type of the church, expresses the same truth. The command given to her ran: “You shall gather to yourself into your house, your father, and your mother, and your brothers, and all your father’s household; and whosoever shall go out of the doors of your house into the street, his blood shall be upon his head.” This figure declares that all who are to live and escape the destruction of the world must be gathered into one house alone, the church, while if any of the gathered goes outside, that is, if anyone who once obtained grace in the church nevertheless abandons the church, his blood will be upon his head, that is, he will have himself to blame for his damnation. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER")]), _vm._v(" 69.4."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN96",
      "id": "ap_part1_NFIN96-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-024"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("2:21 ")])]), _vm._v("She Bound the Scarlet Cord")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGN OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(": A harlot saw this; and she who in the destruction of the city lost all hope of any means of safety, because her faith had conquered, bound a scarlet thread in her window, and thus uplifted a sign of her faith and the banner of the Lord’s passion; so that the semblance of the mystic blood, which should redeem the world, might be in memory. So, from outside the city, the name of Joshua was a sign of victory to those who fought. From within, the semblance of the Lord’s passion was a sign of salvation to those in danger. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(" 5.10.127."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN97",
      "id": "ap_part1_NFIN97-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CARLET")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": So, too, with a mystic reference to the shedding of blood, it was a scarlet cord which the harlot Rahab (a type of the church) hung in her window that she might be saved at the destruction of Jericho. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER")]), _vm._v(" 52.3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN98",
      "id": "ap_part1_NFIN98-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGN OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOOD")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": She herself puts the scarlet-colored sign in her house, through which she is bound to be saved from the destruction of the city. No other sign would have been accepted, except the scarlet-colored one that carried the sign of blood. For she knew there was no salvation for anyone except in the blood of Christ. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 3.5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN99",
      "id": "ap_part1_NFIN99-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDOW A")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE OF THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCARNATION")]), _vm._v(".")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": In that the sign hangs in a window I think this is indicated: A window is that which illumines the house and through which we receive light, not wholly but enough, enough to suffice for the eye and for our vision. Even the incarnation of the Savior did not give us pure "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("wine and the whole aspect of divinity, but through his incarnation, just as through the window, he makes us behold the splendor of the divinity. For that reason, so it seems to me, the sign of salvation was given through a window. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 3.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN100",
      "id": "ap_part1_NFIN100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09559184","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap5.vue
// module id = 93
// module chunks = 0